import { useState, useEffect } from "react";
import { getGoogleDomainDetails } from '../../../http/DomainHttp'
import PageTitle from '../../../components/PageTitle'
import Div from "../../../components/Div";
import { Dropdown } from 'react-bootstrap'
import Input from "../../../components/Input";
import { BsFilter } from "react-icons/bs";
import { Pagination, Stack } from "@mui/material";
import { getShivaamiPortal } from "../../../http/ShivaamiHttp";
import FormButton from "../../../components/FormButton";
import { GoogleAddLicenseModal } from "../../../components/GoogleAddLicenseModal";

export default function AdminAddLicense() {

    const [domainList, setDomainList] = useState([]);
    // const [isAscending, setIsAscending] = useState(true);
    const [modalClicked, setModalClicked] = useState(false)
    const [initailDomainList, setInitialDomainList] = useState([])
    // const [googleDomain, setGoogleDomain] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentItems = domainList.slice(indexOfFirstItem, indexOfLastItem);

    // Calculate total pages
    const totalPages = Math.ceil(domainList.length / itemsPerPage);

    // Change page
    const paginate = (event, value) => {
        setCurrentPage(value);
    };

    const getDomains = async () => {
        const response = await getShivaamiPortal()
        setDomainList(response.customer)
        setInitialDomainList(response.customer)
    }
    useEffect(() => {

        getDomains()

    }, []);

    function handleSearchDomain(event) {

        const search = event.target.value;
        const filteredList = initailDomainList.filter((domain) => {

            if (domain && domain.customer_domain) {

                return domain.customer_domain.toLowerCase().includes(search.toLowerCase());
            }
            else {
                return false
            }
        });

        setDomainList(filteredList);

    }


    function handleStatusFilter(filterState) {

        const filteredList = initailDomainList.filter((user) => {
            if (user && user.domain_status) {

                return user.domain_status.toLowerCase().includes(filterState.toLowerCase());
            } else {
                return false;
            }
        });

        setDomainList(filteredList);
    }

    async function handleDomainClick(subscription_id, domain_name, usedSeats, maxSeats, plan, customer_id) {
        let seats = 0
        const googleSubscriptionResponse = await getGoogleDomainDetails(subscription_id, customer_id)
        if (googleSubscriptionResponse.subscription.seats) {
            if (plan === 'ANNUAL') {
                seats = googleSubscriptionResponse.subscription.seats.numberOfSeats
            } else if (plan === 'FLEXIBLE') {
                seats = googleSubscriptionResponse.subscription.seats.licensedNumberOfSeats
            }

            console.log(googleSubscriptionResponse.subscription.seats)
        }
        else {
            alert('No Subscription for this Domain')
        }

        console.log({ 'subscription': subscription_id, 'domain_name': domain_name })
        setModalClicked({
            'subscription': subscription_id, 'domain_name': domain_name,
            'seats': seats, 'plan': plan, 'customer_id': customer_id
        })
        // setSubscriptionList({'subscription':subscription_id, 'domain_name':domain_name})

    }

    // const sortData = () => {
    //     const sorted = [...initailDomainList].sort((a, b) => {
    //       const dateA = new Date(a.timestamp);
    //       const dateB = new Date(b.timestamp);
    //       return isAscending ? dateA - dateB : dateB - dateA;
    //     });
    //     setDomainList(sorted)
    //     // setSortedData(sorted);
    //     setIsAscending(!isAscending);
    //   };

    return (
        <>
            {/* {subscriptionList ? <GoogleSubscriptionModal show={true.toString()} domain_name={subscriptionList.domain_name} googleLicense={subscriptionList.subscription} open handleClicked={setSubscriptionList} /> :null}
            {modalClicked ? <EditDomainModal updateState={getDomains} show={true.toString()} open domain_name={modalClicked} handleClicked={handleModalClicked} /> : null} */}
            <Div className="form-group">
                {modalClicked ? <GoogleAddLicenseModal googleLicense={modalClicked}
                    show={true.toString()} domain_name={modalClicked.domain_name}
                    open handleClicked={setModalClicked} /> :
                    null}
                Add License {modalClicked.domain_name}
            </Div>

            <PageTitle title='All Domain' />
            <Div className="col-md-12">
                <Div className="page-header-toolbar">

                    <Div className="btn-group toolbar-item" role="group" >
                        <Input type="text" name="email" id="email" onChange={handleSearchDomain} />
                    </Div>

                    <Div className="filter-wrapper">
                    </Div>
                    <span>
                        <Dropdown>
                            <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
                                <BsFilter />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() => handleStatusFilter('Active')}
                                >
                                    Active
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => handleStatusFilter('Rejected')}
                                >
                                    Rejected
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => handleStatusFilter('Suspended')}
                                >
                                    Suspended
                                </Dropdown.Item>

                            </Dropdown.Menu>

                        </Dropdown>

                    </span>
                </Div>
            </Div>


            <Div className="col-md-12 margin_top">
                {/* {currentPage} */}
                {currentItems ?
                    <>
                        <table className="table" border="1">
                            <thead>
                                <tr>
                                    <th>Domain Name</th>
                                    <th>Sku Name</th>
                                    <th>Domain Type</th>
                                    <th>Licensed Seats</th>
                                    <th>Number of Seats</th>
                                    <th>Plan Name</th>
                                    <th>Price</th>
                                    <th>Status</th>
                                    <th>Shivaami Renewal Date</th>
                                    <th>Google Renewal Date</th>
                                    <th>Add License</th>

                                </tr>
                            </thead>
                            <tbody id="tableBody">
                                {currentItems.map((customer) =>

                                    <tr key={customer.subscription_id}>
                                        <td>
                                            {customer.customer_domain}
                                            {/* <button onClick={()=>handlecustomerClick(customer.customer_id)} className="btn btn-link ">{customer.customer_name}</button> */}
                                        </td>
                                        <td>{customer.sku_name}</td>
                                        <td>{customer.reseller_type}</td>
                                        <td>{customer.number_of_seats}</td>
                                        <td>{customer.licensed_seats}</td>
                                        <td>{customer.plan_name}</td>
                                        <td>{customer.price}</td>
                                        <td>{customer.status}</td>
                                        <td>{customer.shivaami_renewal_date}</td>
                                        <td>{customer.google_renewal_date}</td>
                                        <td>
                                            <FormButton type="button" className="btn btn-primary"
                                                onClick={() => handleDomainClick(customer.subscription_id, customer.customer_domain,
                                                    customer.number_of_seats, customer.licensed_seats, customer.plan_name, customer.customer_id
                                                )}
                                                style={{ opacity: '0.8' }}>Add License</FormButton>
                                        </td>
                                    </tr>
                                )

                                }
                            </tbody>
                        </table>

                    </>
                    :
                    <>
                        <p style={{ marginTop: '30px' }}>Not Domain Present or Could not fetch Domains</p>
                    </>}

                {currentItems.length > 0 ?
                    <Stack spacing={2}>
                        <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

                        </Pagination>
                    </Stack>
                    : null}
            </Div>
        </>
    )
}